const getPendingTasks = () => {
  const pendingTasks = localStorage.getItem("pendingTasks")
    ? JSON.parse(localStorage.getItem("pendingTasks"))
    : null;

  return pendingTasks;
};

const InitialState = {
  pendingTasks: getPendingTasks(),
};

const PendingTasksReducer = (state = InitialState, action) => {
  if (action.type === "Save_Pending_Tasks") {
    const newState = {
      ...state,
      pendingTasks: action.payload,
    };
    localStorage.setItem("pendingTasks", JSON.stringify(action.payload));
    return newState;
  }

  else if (action.type === "Remove_User") {
    localStorage.removeItem("pendingTasks");
    const newState = {
      pendingTasks: null
    };
    return newState;
  }

  return state;
};

export default PendingTasksReducer;